export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_Expenseitem') || '费用项目',
    field: 'expenseName',
    align: 'center',
    width: 200,
    editRender: { enabled: true },
    slots: { edit: 'expense' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_Originalamount') || '原币金额',
    field: 'currencyAmount',
    align: 'center',
    width: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_Expensecustomer') || '费用客户',
    field: 'custName',
    align: 'center',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'customer' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    align: 'center',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custOrderNo' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_Expensedescription') || '费用说明',
    field: 'expenseRemark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        precision: 2,
        min: 0,
        step: 0.01,
        'controls-position': 'left',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
